import React, { Component } from 'react';

class Contact extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var website = this.props.data.website;
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">

         <div className="row section-head">

            <div className="two columns header-col">

               <h1><span>Get In Touch.</span></h1>

            </div>

            <div className="ten columns">

                  <p className="lead">{message}</p>

            </div>

         </div>

         <div className="row">
            <div className="eight columns contact-primary">
               <div className="contact-panel">
                  <h4>Open to architecture, platform, and consulting conversations.</h4>
                  <p>
                     I work with teams building complex systems where scalability, resilience, and real-world delivery constraints all matter at the same time.
                  </p>
                  <div className="contact-actions">
                     <a className="button" href={"mailto:" + email}><i className="fa fa-envelope"></i>Email Me</a>
                     <a className="button button-ghost" href={website}><i className="fa fa-globe"></i>Visit Website</a>
                  </div>
               </div>
           </div>


            <aside className="four columns footer-widgets">
               <div className="widget widget_contact">

					   <h4>Direct Contact</h4>
					   <p className="address">
						   {name}<br />
						   {street} <br />
						   {city}, {state} {zip}<br />
						   <span>{phone}</span><br />
                     <span>{email}</span>
					   </p>
				   </div>
            </aside>
      </div>
   </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js